import { render, staticRenderFns } from "./ChatOpenBtn.vue?vue&type=template&id=80535804&"
import script from "./ChatOpenBtn.vue?vue&type=script&lang=js&"
export * from "./ChatOpenBtn.vue?vue&type=script&lang=js&"
import style0 from "./ChatOpenBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports